export default __webpack_public_path__ + "static/media/user-edit.f0a70576.svg";